import { SELL_ONLINE_STEP_KEY } from "../../../constants/sell-online-constant";

export const LEAD_STEPS = [
    {
        name: "brand",
        index: 1
    },
    {
        name: "model",
        index: 2
    },
    {
        name: "year",
        index: 3
    },
    {
        name: "fuelType",
        index: 4
    },
    {
        name: "transmission",
        index: 5
    },
    {
        name: "variant",
        index: 6
    },
    {
        name: "kilometersDriven",
        index: 7
    },
    {
        name: "registrationState",
        index: 8
    },
    {
        name: "rto",
        index: 9
    }
];

export const SELL_ONLINE_POST_OFFER_TAB_LIST = [
    {
        heading: "Instant payment and pick up",
        index: 1
    }
];

export const SELL_ONLINE_STEPS = [
    { name: SELL_ONLINE_STEP_KEY.BASIC_DETAILS, index: 1 },
    { name: SELL_ONLINE_STEP_KEY.CAR_CONDITION, index: 2 },
    { name: SELL_ONLINE_STEP_KEY.FINAL_OFFER, index: 3 },
    { name: SELL_ONLINE_STEP_KEY.APPOINTMENT_DETAILS, index: 4 },
    { name: SELL_ONLINE_STEP_KEY.DOCUMENT_UPLOAD, index: 5 }

];
